import { render } from "./FirmSelector.vue?vue&type=template&id=62e028a3&ts=true"
import script from "./FirmSelector.vue?vue&type=script&lang=ts"
export * from "./FirmSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__